import { useMutation } from "@tanstack/react-query";
import { z } from "zod";

import { useLang } from "@/hooks/use-lang";
import { Lang } from "@/i18n-config";
import { createHttpErrorMessage } from "@/utils/create-http-error-message";

export interface SendContactEmailParams {
  username: string;
  email: string;
  content: string;
  lang: Lang;
}

const responseDataSchema = z.object({
  statusCode: z.number(),
  message: z.string(),
});

export type ResponseData = z.infer<typeof responseDataSchema>;

export const sendContactEmail = async ({
  content,
  email,
  username: user_name,
  lang,
}: SendContactEmailParams): Promise<ResponseData> => {
  const url = "https://api.growin.tv/phoenix/contact";
  const res = await fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "x-api-key": "jF5tteXaZpV4ONOEODmlw50GBQgyz9BiWl4QJ300",
      "Accept-Language": lang,
    },
    body: JSON.stringify({ content, email, user_name }),
  });
  if (!res.ok) {
    const errorMessage = await createHttpErrorMessage(url, res);
    throw new Error(errorMessage);
  }
  return responseDataSchema.parse(await res.json());
};

export const useSendContactEmail = () => {
  const { lang } = useLang();
  return useMutation((params: Omit<SendContactEmailParams, "lang">) =>
    sendContactEmail({ ...params, lang })
  );
};
